package com.mencanhealth.admin.ui

import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.css.*
import com.mencanhealth.admin.model.*

@Composable
fun QuestionnaireResponsesViewer(appointmentType: String, responsesJson: String) {
    if (responsesJson.isBlank()) return

    val type = try { AppointmentType.valueOf(appointmentType) } catch (_: Exception) { return }
    val questions = questionnaireForType(type)

    // Parse the JSON responses: {"questionId":"answer", ...}
    val responses = parseResponsesJson(responsesJson)
    if (responses.isEmpty()) return

    val sections = questions.map { it.section }.distinct()

    H3({ style { property("margin-top", "24px") } }) { Text("Cuestionario del Paciente") }

    sections.forEach { sectionName ->
        val sectionQuestions = questions.filter { it.section == sectionName }
        val sectionIcon = sectionQuestions.first().sectionIcon
        val hasAnswers = sectionQuestions.any { responses.containsKey(it.id) && responses[it.id]?.isNotBlank() == true }
        if (!hasAnswers) return@forEach

        Div({ classes("detail-card"); style { property("margin-bottom", "16px") } }) {
            H4({ style { property("margin-bottom", "12px"); color(Color("#283593")) } }) {
                Img(src = sectionIcon, alt = "") { style { property("width", "24px"); property("height", "24px"); property("object-fit", "contain"); property("display", "inline-block"); property("vertical-align", "middle"); property("margin-right", "8px") } }
                Text(sectionName)
            }

            sectionQuestions.forEach { q ->
                val answer = responses[q.id]
                if (answer.isNullOrBlank()) return@forEach

                Div({ classes("detail-row") }) {
                    Span({ classes("detail-label"); style { property("width", "auto"); property("min-width", "200px"); property("max-width", "300px") } }) {
                        Text(q.question)
                    }
                    Div({ style { property("flex", "1") } }) {
                        when (q.type) {
                            QuestionType.MULTI_SELECT -> {
                                Div({ style { display(DisplayStyle.Flex); property("gap", "6px"); flexWrap(FlexWrap.Wrap) } }) {
                                    answer.split("|||").filter { it.isNotBlank() }.forEach { chip ->
                                        Span({ classes("chip", "chip-active"); style { property("font-size", "12px"); property("padding", "2px 10px") } }) {
                                            Text(chip)
                                        }
                                    }
                                }
                            }
                            QuestionType.SLIDER -> {
                                Div({ style { display(DisplayStyle.Flex); alignItems(AlignItems.Center); property("gap", "8px") } }) {
                                    val value = answer.toIntOrNull() ?: 0
                                    val pct = if (q.max > q.min) ((value - q.min) * 100) / (q.max - q.min) else 0
                                    Div({
                                        style {
                                            property("width", "120px"); property("height", "8px")
                                            property("background", "#e0e0e0"); property("border-radius", "4px")
                                            property("overflow", "hidden")
                                        }
                                    }) {
                                        Div({
                                            style {
                                                property("width", "${pct}%"); property("height", "100%")
                                                property("background", "#283593"); property("border-radius", "4px")
                                            }
                                        }) {}
                                    }
                                    Span({ style { property("font-weight", "700"); color(Color("#283593")) } }) {
                                        Text("$value / ${q.max}")
                                    }
                                }
                            }
                            QuestionType.EMOJI_SELECT -> {
                                val emoji = answer.substringBefore(" ")
                                val label = answer.substringAfter(" ")
                                Span({ style { property("font-size", "20px") } }) { Text(emoji) }
                                Span({ style { property("margin-left", "8px") } }) { Text(label) }
                            }
                            else -> {
                                Span { Text(answer) }
                            }
                        }
                    }
                }
            }
        }
    }
}

private fun parseResponsesJson(json: String): Map<String, String> {
    return try {
        val parsed = kotlin.js.JSON.parse<dynamic>(json)
        val keys = js("Object.keys(parsed)") as Array<String>
        keys.associate { key -> key to (parsed[key] as? String ?: parsed[key].toString()) }
    } catch (_: Exception) {
        emptyMap()
    }
}
